import { Icon } from '@wyz/ui';
import * as React from 'react';

type IconProps = React.ComponentProps<typeof Icon>;
type Feature = 'eco' | 'sport' | 'electric';

const CarFeatureIcon = ({
  value,
  size = 'lg',
}: {
  value: Feature;
  size?: IconProps['size'];
}) => {
  const FEATURE_ICON: { [key in Feature]: React.ReactNode } = {
    eco: <Icon icon='leaf-line' size={size} />,
    electric: <Icon icon='plug-line' size={size} />,
    sport: <Icon icon='dashboard' size={size} />,
  };

  return <>{FEATURE_ICON[value]}</>;
};

export default CarFeatureIcon;
